import '@/core/js/Copyright'
import _ from 'lodash'
import Vue from 'vue'
import Axios from 'axios'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import VueLazyload from 'vue-lazyload'

import App from '@/App.vue'
import store from '@/vuex/Store'
import router from '@/Route.js'
import Settings from '@/config/Settings'
import Translation from '@/core/mixins/Translation'
import LangMixin from '@/core/mixins/Lang'
import Agent from '@/core/js/Agent'
import AframeMixin from '@/mixins/Aframe'
import '@/commons/js/gsap/AframePlugin'

Vue.prototype.$http = Axios.create({ baseURL: Settings.API_URL })
Vue.use(VueRouter)
Vue.use(Meta,{
  keyName: 'head'
})
Vue.use(VueLazyload)
Vue.mixin(Translation)
Vue.mixin(AframeMixin)

if((process.env.NODE_ENV !== 'production') && (Agent.browser.name == 'Safari' || Agent.browser.name == 'Firefox'))
  Vue.config.ignoredElements = [ 'a-asset-item', 'a-sky', 'a-cursor', 'a-gltf-model', 'a-scene', 'a-entity', 'a-plane', 'a-box', 'a-assets', 'a-text', 'a-camera', 'a-image', 'a-video', 'a-circle', 'a-ring']

new Vue({
  el: '#App',
  store,
  router,
  mixins: [ LangMixin ],
  head() {
    return {
      htmlAttrs: { lang: this.lang },
      title: this.trans('Global.meta.title'),
      meta: [
        { name: 'viewport', content: 'width=device-width, initial-scale=1, viewport-fit=cover' },
        // { vmid: 'description', name: 'description', content: this.trans('Global.meta.description')},
				// { property: 'og:title', content: this.trans('Global.meta.title')  },
				// { property: 'og:description', content: this.trans('Global.meta.description')  },
				// { property: 'twitter:description', content: this.trans('Global.meta.twitter')  },
      ],
    }
  },
  data: () => ({
    $agent: null,
    isDev: process.env.NODE_ENV !== 'production',
    locked: false,
    redirect: {},
    noheader: true,
    onProd: false,
    neverShowHeader: false
  }),
  beforeCreate() {
    this.$store.commit('app/LANG_CHANGED', this.$route.meta.lang)
    this.$store.commit('app/SET_FROM_ROUTE', this.$route)
    this.$store.commit('app/SET_TO_ROUTE', this.$route)
  },
  created() {
    this.$agent = Agent
    this.onProd = window.location.hostname == 'roxham.onf.ca' || window.location.hostname == 'roxham.nfb.ca'
    this.locked = this.$root.$agent.mobile || this.$root.$agent.browser.name == 'Safari'
    this.noheader = this.$route.query.noheader == 'true' ? true : false
    if(Settings.localAssets) {
      this.customHeader = true
      this.onProd = true
      this.locked = false
    }

    this.redirect = this.$route.meta.name != 'lock' && !this.onProd
      ? { ...this.$route }
      : { name: 'load.' + this.lang }

    // this.locked = true
    // this.onProd = true

    if(!this.$root.locked && this.$route.meta.name == 'lock')
      return this.$router.push({ name: 'load.' + this.lang })

    if(this.$root.locked)
      return this.$router.push({ name: 'lock.' + this.lang })

    if(this.onProd && this.$route.meta.name != 'load')
      return this.$router.push({ name: 'load.' + this.lang })
  },
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js